import React from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  Box,
  useTheme
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

type SearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  sx?: object;
};

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  fullWidth = true,
  size = 'small',
  sx = {}
}) => {
  const theme = useTheme();

  const handleClear = () => {
    onChange('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <Box sx={sx}>
      <TextField
        fullWidth={fullWidth}
        size={size}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            </InputAdornment>
          ),
          endAdornment: value && (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={handleClear}
                edge="end"
                sx={{
                  color:
                    theme.palette.mode === 'dark'
                      ? 'rgb(77, 182, 207)'
                      : 'rgb(1, 103, 124)'
                }}
              >
                <ClearIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </InputAdornment>
          ),
          sx: {
            backgroundColor: 'background.paper'
          }
        }}
      />
    </Box>
  );
};
